import React, { useState } from 'react';

import Switch from '../../elements/Switch';
import GiftSlider from '../../elements/GiftSlider';

import OnlyConditions from './OnlyConditions';

const Tabs = props => {
	const [isGifts, setGifts] = useState( true );
	if ( props.bloggerData.hasGifts === 1 ) {
		return (
			<div className={ isGifts && props.width <= 600 ? 'tabs_R' : 'tabs' }>
				<Switch isGifts={ isGifts } showConditionsFirst={ props.bloggerData.showConditionsFirst } setGifts={ setGifts } width={ props.width }/>
				{props.width >= 600 ? <div className="tabs_container">
					{!isGifts !== !props.bloggerData.showConditionsFirst ? (	// XOR
							<GiftSlider bloggerData={ props.bloggerData } width={ props.width }/>

					) : (
						<div className="tabs_conditions_container">
							<div
								className="tabs_conditions"
								dangerouslySetInnerHTML={ {
									__html: props.bloggerData.conditions
								} }
							/>
						</div>
					) }
				</div> :
					!isGifts !== !props.bloggerData.showConditionsFirst ?	// XOR
						<GiftSlider bloggerData={ props.bloggerData } width={ props.width }/> : (
							<div className="tabs_container">
								<div className="tabs_conditions_container">
									<div
										className="tabs_conditions"
										dangerouslySetInnerHTML={ {
											__html: props.bloggerData.conditions
										} }
									/>
								</div>
							</div>
						)
				}
			</div>
		);
	} else {
		return <OnlyConditions bloggerData={ props.bloggerData }/>;
	}
};

export default Tabs;
